<div class="fc-text-area-input" [class.invalid]="control.touched && control.errors">
  <div class="fc-text-area-input__infix" [class.float-label]="control.value">
    <label class="fc-text-area-input__infix-label"> {{ label }}<span *ngIf="requiredMark">*</span> </label>
    <textarea class="fc-text-area-input__infix-input" type="text" [formControl]="control" [maxlength]="maxLength">
    </textarea>
    <small class="fc-text-area-input__infix-hint" *ngIf="maxLength">
      {{ (control.value?.length || 0) + '/' + maxLength }}
    </small>
    <small class="fc-text-area-input__infix-error" *ngIf="control.touched && control.errors">
      {{ translateErrorPrefix + '.' + (control | firstError) | translate }}
    </small>
  </div>
</div>
